
( function( $, window ) {
	'use strict';

	$( function() {
		window.onload = function () {
    var e = document.querySelectorAll("a"),
      t = ["filename1", "filename2", "filename3"],
      n = ["pdf", "doc", "docx", "xls", "xlsx"];
    function o(e, t, n) {
      e.textContent += ` (${n.toUpperCase()})`;
    }
    e.forEach(function (e) {
      var i = e.getAttribute("href");
      if (i) {
        var l = i.split("/").pop().split(".")[0];
        if (t.includes(l)) return;
        var r = i.split(".").pop();
        if (!n.includes(r)) return;
        i.startsWith("http") || (i = window.location.origin + i);
        if (new URL(i, window.location.href).hostname !== window.location.hostname) return void o(e, i, r);
        fetch(i, { method: "HEAD" })
          .then(function (t) {
            if (!t.ok) return console.log(`Failed to fetch: ${i}`), void o(e, i, r);
            var n = t.headers.get("Content-Length");
            if (n) {
              (n /= 1024), n < 1024 ? (e.textContent += ` (${r.toUpperCase()}, ${n.toFixed(2)} KB)`) : ((n /= 1024), (e.textContent += ` (${r.toUpperCase()}, ${n.toFixed(2)} MB)`));
            }
          })
          .catch(function () {
            o(e, i, r);
          });
      }
    });
  };
	} );
} )( jQuery, window );
